import api from "./api";

// Types for reset password requests and responses
export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface RequestResetPasswordRequest {
  email: string;
}

export interface ResetPasswordResponse {
  success: string;
  message: string;
  status: string;
}

export const resetPasswordService = {
  // Request password reset email
  async requestResetPassword(
    email: string
  ): Promise<ResetPasswordResponse> {
    try {
      const response = await api.post<ResetPasswordResponse>(
        "/users/reset-password",
        { email }
      );
      return response.data;
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response: { data: ResetPasswordResponse } };
        console.error("REQUEST RESET PASSWORD ERROR:", axiosError.response.data);
        return axiosError.response.data;
      } else {
        console.error("REQUEST RESET PASSWORD UNKNOWN ERROR:", String(error));
        throw error;
      }
    }
  },

  // Reset password with token
  async resetPassword(
    token: string,
    newPassword: string
  ): Promise<ResetPasswordResponse> {
    try {
      const response = await api.post<ResetPasswordResponse>(
        "/users/change-password",
        { token, newPassword }
      );
      return response.data;
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response: { data: ResetPasswordResponse } };
        console.error("RESET PASSWORD ERROR:", axiosError.response.data);
        return axiosError.response.data;
      } else {
        console.error("RESET PASSWORD UNKNOWN ERROR:", String(error));
        throw error;
      }
    }
  },
};
